import React, { FC, useCallback } from 'react';

import { GeneralThemesSettingsDatasyncService } from '@ps-int/general-themes';
import VideoBgSwitch from '@ps-int/general-themes-components/components/VideoBgSwitch';
import { connect } from 'react-redux';

import { countMetrika } from '../../../../helpers/metrika';
import { setVideoBg } from '../../../config/index';

const mapDispatchToProps = {
    setVideoBg,
};

const connector = connect(null, mapDispatchToProps);

type VideoBgSwitchWrapperProps = typeof mapDispatchToProps & { ds: GeneralThemesSettingsDatasyncService };

const VideoBgSwitchWrapper: FC<VideoBgSwitchWrapperProps> = ({ ds, setVideoBg }) => {
    const handleVideoBgEnabled = useCallback(() => {
        countMetrika('interface elements', 'settings popup', 'videobackground', 'on');
        setVideoBg(true);
    }, [setVideoBg]);

    const handleVideoBgDisabled = useCallback(() => {
        countMetrika('interface elements', 'settings popup', 'videobackground', 'off');
        setVideoBg(false);
    }, [setVideoBg]);

    return <VideoBgSwitch ds={ds} onVideoBgEnabled={handleVideoBgEnabled} onVideoBgDisabled={handleVideoBgDisabled} />;
};

export default connector(VideoBgSwitchWrapper);
